import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "comment--sprite",
  "use": "comment--sprite-usage",
  "viewBox": "0 0 45 44",
  "content": "<symbol viewBox=\"0 0 45 44\" xmlns=\"http://www.w3.org/2000/svg\" id=\"comment--sprite\">\n<path d=\"M7.54688 30.2144V6.34375H36.5469V17.2188H40.1719V6.34375C40.1719 4.35 38.5406 2.71875 36.5469 2.71875H7.54688C5.55312 2.71875 3.94 4.35 3.94 6.34375L3.92188 38.9688L11.1719 31.7188H27.4844V28.0938H9.6675L7.54688 30.2144Z\" />\n<path d=\"M41.0781 28.0938H37.0906L40.1719 20.8438H31.1094V31.7188H34.7344V40.7812L41.0781 28.0938Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol